
export const RE_CAPTCHA_KEY = '6LchQtQUAAAAAMS7j8ey4DlasaVQBpHAg1VaJ0y-';

export const APP_VERSION = 1.6;

const development = {
    BASE_URL: 'https://affiliateapi.devdigitain.com',
    BASE_DOMAIN: 'https://dev.webaffiliates.net',
    CDN_URL: '.agbuilder.io/en/',
    BUILDER_URL: 'https://builder-dev.com',
    LANGUAGES: ['en', 'fa'],
};

const test = {
    BASE_URL: 'https://affiliateapi.tst-digi.com',
    BASE_DOMAIN: 'https://webaffiliates.tst-digi.com',
    CDN_URL: '.agbuilder.io/en/',
    BUILDER_URL: 'https://builder-tst.com',
    LANGUAGES: ['en'],
};

const staging = {
    BASE_URL: 'https://affiliateapi.stgapidigi.com',
    BASE_DOMAIN: 'https://webaffiliates.stgdigitain.com',
    CDN_URL: '.agbuilder.io/en/',
    BUILDER_URL: 'https://builder-stg.com',
    LANGUAGES: ['en', 'fa'],
};

const prodAlbatross = {
    BASE_URL: 'https://affiliateapiir.apidigi.com',
    BASE_DOMAIN: 'https://webaffiliates.net',
    CDN_URL: '.agbuilder.io/en/',
    BUILDER_URL: 'https://agbuilder.io',
    LANGUAGES: ['en', 'fa'],
};

const prodShared = {
    BASE_URL: 'https://adminapi.webaffiliatesd.com',
    BASE_DOMAIN: 'https://www.webaffiliatesd.com',
    CDN_URL: '.dgbuilder.io/en/',
    BUILDER_URL: 'https://dgbuilder.io',
    LANGUAGES: ['en'],
};

const prodAl = {
    BASE_URL: 'https://adminapi.webaffiliateal.com',
    BASE_DOMAIN: 'https://www.webaffiliateal.com',
    CDN_URL: '.dgbuilder2.io/en/',
    BUILDER_URL: 'https://dgbuilder2.io',
    LANGUAGES: ['en'],
};

const prodLechu = {
    BASE_URL: 'https://adminapi.webaffiliatelu.com',
    BASE_DOMAIN: 'https://www.webaffiliatelu.com',
    CDN_URL: '.dgbuilder3.io/en/',
    BUILDER_URL: 'https://dgbuilder3.io',
    LANGUAGES: ['en'],
};



export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

//REACT_APP_STAGE=dev npm run build
const enviroments = {
    'dev': development, 
    'tst': test, 
    'stg': staging, 
    'prd:albatross': prodAlbatross, 
    'prd:shared': prodShared,
    'al': prodAl,
    'lechu': prodLechu
}

const config = enviroments[process.env.REACT_APP_STAGE] ? enviroments[process.env.REACT_APP_STAGE] : isLocalhost ? test : development;
export default config;


// WEBPACK FOOTER //
// ./src/constants/Configs.js